// @flow
import React, {useEffect, useState} from 'react';
import {FormattedMessage} from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import type {Car} from '../../types';
import Field from '../ui/Field';
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles(theme => ({
    error: {
        backgroundColor: theme.palette.error.dark,
    }
}));

export type Props = $ReadOnly<{
    car?: Car,

    onClose: () => void,
    createCar: (car: Car) => Promise<any>
}>;

function CarForm({car, onClose, createCar}: Props) {
    const classes = useStyles();
    const [innerCar, setInnerCar] = useState(car);
    const [formError, setFormError] = useState();

    useEffect(() => {
        setInnerCar(car);
    }, [car]);

    const handleChange = (key) => (e) => {
        setInnerCar({
            ...innerCar,
            [key]: e.target.value
        });
        setFormError(null);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        createCar(innerCar)
            .then(() => onClose())
            .catch(setFormError);
    };

    return (
        <Box m={2}>
            <form onSubmit={handleSubmit}>
                <Field
                    label={(
                        <FormattedMessage
                            id="carForm.callsign"
                            defaultMessage="Callsign"
                        />
                    )}
                    value={innerCar && innerCar.callsign}
                    onChange={handleChange('callsign')}
                />
                <Field
                    label={(
                        <FormattedMessage
                            id="carForm.icao"
                            defaultMessage="ICAO"
                        />
                    )}
                    value={innerCar && innerCar.icao}
                    onChange={handleChange('icao')}
                />

                {formError &&
                <FormControl margin="dense" fullWidth>
                    <SnackbarContent
                        className={classes.error}
                        message={(
                            <FormattedMessage
                                id="carForm.error"
                                defaultMessage="An error has occurred"
                            />
                        )}
                    />
                </FormControl>
                }

                <FormControl margin="dense" fullWidth>
                    <Box display="flex" justifyContent="flex-end">
                        <Button
                            size="large"
                            variant="outlined"
                            onClick={onClose}
                            color="primary"
                        >
                            <FormattedMessage
                                id="carForm.cancelButton"
                                defaultMessage="Cancel"
                            />
                        </Button>
                        <Box ml={2}>
                            <Button
                                size="large"
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                <FormattedMessage
                                    id="carForm.saveCTA"
                                    defaultMessage="Add"
                                />
                            </Button>
                        </Box>
                    </Box>
                </FormControl>
            </form>
        </Box>
    );
}

export default CarForm;